import { useLocation } from "react-router-dom";

export const useExtractGoogleReviewReplyQueryParams = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const since = queryParams.get('since');
  const until = queryParams.get('until');
  const rating = queryParams.get('rating');

  const queryParamItems = [];
  if (since) queryParamItems.push(`since=${since}`);
  if (until) queryParamItems.push(`until=${until}`);
  if (rating) queryParamItems.push(`rating=${rating}`);

  const requestQueryParams = queryParamItems.length !== 0 ? `?${queryParamItems.join('&')}` : '';

  return requestQueryParams;
};